"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useParsedPathParams = void 0;

var _react = require("react");

var _params = require("../params");

var useParsedPathParams = function useParsedPathParams() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _react.useMemo)(function () {
    return (0, _params.getParsedPathParams)(params);
  }, [params]);
};

exports.useParsedPathParams = useParsedPathParams;


//////////////////
// WEBPACK FOOTER
// ./js/utils/hooks/useParsedPathParams.js
// module id = 200
// module chunks = 209 210 211 212